import axios from 'axios';
import Cookie from 'js-cookie';
import router from '@/router/index';
import { notice } from '@/utils/index';
/* eslint-disable */

const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://visionhealthmed.com' : '',
  timeout: 50000,
});

const CancelToken = axios.CancelToken;

const urlControl = [];

const clearParamsUrl = (url) => {
  const sliceIndex = String(url).indexOf('?');
  const clearUrl = sliceIndex === -1 ? url : String(url).slice(0, sliceIndex);
  return clearUrl;
};

// 添加请求拦截器
instance.interceptors.request.use((config) => {

  const { method } = config;

  const url = clearParamsUrl(config.url);

  const pnd = method === 'post' || method === 'delete';

  const repeatIndex = urlControl.findIndex((f) => f.url === url);

  if (pnd && repeatIndex !== -1) {
    config.cancelToken = new CancelToken(c => {
      c();
    });
  }

  if (pnd && repeatIndex === -1) {
    const timestamp = new Date().getTime();
    config.timestamp = timestamp;
    config.cancelToken = new CancelToken(c => {
      urlControl.push({
        cancel: c,
        timestamp,
        url: url,
      });
    });
  }

  if (typeof config.data === 'string' && config.method === 'post') {
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
  }

  if (typeof config.data === 'string' && config.method === 'put') {
    config.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
  }

  return config;
}, (error) =>
  // 对请求错误做些什么
  Promise.reject(error));
// 添加响应拦截器
instance.interceptors.response.use((response) => {
  return new Promise((resolve, reject) => {
    // 清除请求结束的url
    const { timestamp, method } = response.config;
    if (method === 'post' || method === 'delete') {
      const deleteIndex = urlControl.findIndex((f) => f.timestamp === timestamp);
      urlControl.splice(deleteIndex, 1);
    }
    const result = JSON.parse(JSON.stringify(response.data));
    if (result.code === 1401 && result.message === '身份过期，请求重新登录') {
      Cookie.remove('user_info');
      notice('warning', '提示', '身份过期，请求重新登录', 5);
      router.push('/login');
      reject('log out')
    } else {
      resolve(response.data);
    }
  })
}
  // 对响应数据做点什么
  ,
  (error) =>
    // 对响应错误做点什么
    Promise.reject(error));

export default instance;

/* eslint-disable */
